import React, { useEffect, useState, forwardRef } from 'react';
import Modal from '../Modal';

import {
  IconSbag,
  IconSend,
  ModalHeadBox,
  ModalHeadBtn,
  ModalTitle,
  NotifyModalInfoBox,
  NotifyModalItem,
  NotifyModalList,
  NotifyModalText,
  NotifyModalTime,
  NotifyModalTitle
} from './NotificationModal.styled';

import { useReadNotificationsMutation } from '../../../redux/notification/notificationApi';
import { formatTimeDate } from 'utils/function';
import ModalMessage from '../ModalMessage';
import { useNavigate } from 'react-router-dom';
import ImageAnimation2 from 'components/layout/loader/ImageAnimation2';
import { Span1, Span2 } from 'components/main/AddBag/AddBag.styled';

const NotificationModal =({ onClose, notificationsAr, setNotificationsAr, markUnread }) => {
  const navigate = useNavigate();
  const [readNotifications, { isLoading: isLoadingMes }] = useReadNotificationsMutation();
  console.log('object :>> ', notificationsAr);

  const handleRead = async () => {
    if (markUnread) return;
    const ids = notificationsAr.filter(item => !item.read).map(item => item.id).join(',');
    console.log('ids :>> ', ids);
    try {
      await readNotifications(ids).unwrap();
      console.log('Details successfully');
      const updatedNotifications = notificationsAr.map(item =>
        item.read ? item : { ...item, read: true }
      );
      setNotificationsAr(updatedNotifications);
    } catch (error) {
      console.error('Failed to Details:', error);
    }
  };

  const handleReadById = async (id,ids,types) => {
    try {
      console.log('id :>> ', id);
      await readNotifications(`${id}`).unwrap();
      console.log('Details successfully');
      const updatedNotifications = notificationsAr.map(item =>
        item.id === id ? { ...item, read: true } : item
      );
      setNotificationsAr(updatedNotifications);
      console.log('types :>> ', types);
      if (types === null) return;
if (types === null) return;

switch (types) {
  case 'order':
    navigate(`/main/vieworder/${ids}`);
    break;

  case 'dishorder':
    navigate(`/main/vieworder/${ids}?type=dish`);
    break;

  case 'orderFiscalization':
    navigate(`/financial#PRRO`);
    break;

  case 'dishorderFiscalization':
    navigate(`/financial#PRRO`);
    break;

  case 'bag':
    navigate(`/main/viewbag/${ids}`);
    break;

  default:
    // опціонально: fallback
    navigate(`/main/viewbag/${ids}`);
    break;
}

      // if (types === 'order' || types === 'dishorder')
      //   navigate(`/main/vieworder/${ids}${types === 'dishorder' ? "?type=dish" : ""}`);
      // else {
      // navigate(`/main/viewbag/${ids}`);
      // }
    } catch (error) {
      console.error('Failed to Details:', error);
    }
    onClose();
  };

  return (
    <ModalMessage hug={notificationsAr && notificationsAr.length === 0 && true} pad={"false"} onClose={onClose}>
      <ModalHeadBox>
        <ModalTitle>Повідомлення</ModalTitle>
        {isLoadingMes ? (
          <ImageAnimation2 />
        ) : notificationsAr && notificationsAr.length !== 0 ? (
          <ModalHeadBtn onClick={handleRead}>
            <IconSend />
            <Span1>Прочитати всі</Span1>
          </ModalHeadBtn>
        ) : (
          <Span2>немає</Span2>
        )}</ModalHeadBox>
      {notificationsAr && notificationsAr.length !== 0 && <NotifyModalList>
        {notificationsAr.map((notify) =>
          <NotifyModalItem key={notify.id} onClick={() => {
            handleReadById(notify.id,notify.object_id, notify.type)
          }
          } read={notify.read ? "true" : "false"}>
            <IconSbag />
            <NotifyModalInfoBox>
              <NotifyModalTitle>{notify.title}</NotifyModalTitle>
              <NotifyModalText>{notify.message}</NotifyModalText>
              <NotifyModalTime>{formatTimeDate(notify.createdAt)}</NotifyModalTime>
            </NotifyModalInfoBox>
          </NotifyModalItem>
        )}
      </NotifyModalList>}
    </ModalMessage>
  );
};

export default NotificationModal;
